import { useState, useEffect, useRef } from "react";
import api from "@/lib/api";
import { fileUrl } from "@/lib/jobOptions";

export function AdSlot({ slot, rol, provincie, publiek = false, className = "" }) {
  const [banners, setBanners] = useState([]);
  const [idx, setIdx] = useState(0);
  const seenRef = useRef(new Set());

  useEffect(() => {
    let active = true;
    const params = { slot };
    if (rol) params.rol = rol;
    if (provincie) params.provincie = provincie;
    if (publiek) params.publiek = true;
    api.get("/banners/carousel", { params })
      .then(({ data }) => { if (active) { setBanners(data.banners || []); setIdx(0); } })
      .catch(() => {});
    return () => { active = false; };
  }, [slot, rol, provincie, publiek]);

  // Tel een impressie wanneer een slide voor het eerst zichtbaar wordt.
  useEffect(() => {
    const cur = banners[idx];
    if (!cur || seenRef.current.has(cur.id)) return;
    seenRef.current.add(cur.id);
    api.post(`/banners/${cur.id}/impressie`).catch(() => {});
  }, [banners, idx]);

  // Automatische rotatie: elke slide blijft zijn eigen rotatie_seconden zichtbaar.
  useEffect(() => {
    if (banners.length < 2) return;
    const cur = banners[idx];
    const secs = Math.max(2, Number(cur?.rotatie_seconden) || 8);
    const t = setTimeout(() => setIdx((i) => (i + 1) % banners.length), secs * 1000);
    return () => clearTimeout(t);
  }, [banners, idx]);

  if (banners.length === 0) return null;
  const banner = banners[idx];

  const onClick = async () => {
    try {
      const { data } = await api.post(`/banners/${banner.id}/click`);
      if (data.url) window.open(data.url, "_blank", "noopener");
    } catch (e) { /* niet blokkerend */ }
  };

  return (
    <div data-testid={`ad-slot-${slot}`} className={`relative ${className}`}>
      <button type="button" onClick={onClick} className="block w-full" data-testid="ad-banner-link">
        <img key={banner.id} src={fileUrl(banner.afbeelding_id)} alt={banner.titel}
          className="w-full max-h-[140px] object-contain bg-slate-50 rounded-md border border-slate-200 hover:opacity-95 transition-opacity animate-in fade-in duration-500" />
      </button>
      <span className="absolute top-1.5 right-1.5 bg-black/55 text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-sm pointer-events-none">
        Gesponsord
      </span>
      {banners.length > 1 && (
        <div className="absolute bottom-1.5 left-1/2 -translate-x-1/2 flex items-center gap-1.5" data-testid="ad-carousel-dots">
          {banners.map((b, i) => (
            <button key={b.id} type="button" aria-label={`Banner ${i + 1}`}
              onClick={(e) => { e.stopPropagation(); setIdx(i); }}
              className={`h-1.5 rounded-full transition-all ${i === idx ? "w-4 bg-orange-500" : "w-1.5 bg-white/70 border border-slate-300"}`} />
          ))}
        </div>
      )}
    </div>
  );
}
